import React from 'react'
import './Footer.css'
import Whatsapp from '../../assets/whatsapp.png'
import Instagram from '../../assets/instagram.png'
import Facebook from '../../assets/facebook.png'
import Logo from '../../assets/logo.png'
import Location1 from '../../assets/loc1.jpg'
import Location2 from '../../assets/loc2.jpg'

const Footer = () => {
  return (
    <div className='Footer-container'>
      <hr />
      <div className="footer">
        <div className="social-links">
          <a href="https://wa.me/9113245455" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img className='what' src={Whatsapp} alt="Chat with us on WhatsApp" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img className='insta' src={Instagram} alt="Follow us on Instagram" />
          </a>
          <a href="https://fb.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img className='face' src={Facebook} alt="Like us on Facebook" />
          </a>
        </div>

        <div className="locations">
          <div className="location">
            <h4>Main Branch</h4>
            <a href="https://maps.app.goo.gl/m5hRjotpbaVJkZKd8" target="_blank" rel="noopener noreferrer" className="location-link">
              <p>14th Block, 27, 4th Cross Rd,<br />NGEF Layout,Marilingappa Extension, Naagarabhaavi, Bengaluru</p>
              <img src={Location1} alt="Main Branch Location" className="location-image" />
            </a>
          </div>
          <div className="location">
            <h4>Second Branch</h4>
            <a href="https://maps.app.goo.gl/kzQswMLwaCRyDyHbA" target="_blank" rel="noopener noreferrer" className="location-link">
              <p>17, NH75, Venkateshwara Layout, <br />Chikkabasavanapura, Krishnarajapuram, Bengaluru</p>
              <img src={Location2} alt="Second Branch Location" className="location-image" />
            </a>
          </div>
        </div>

        <div className="logo-f-container">
          <div className="logo-f">
            <img src={Logo} alt="Company Logo" />
          </div>
        </div>
      </div>
      <div className="blur blur-f-1"></div>
      <div className="blur blur-f-2"></div>
    </div>
  )
}

export default Footer
